import * as React from 'react';
import { CircledCrossIcon, CircledFilledCheckIcon } from '../Icons';
import { deleteFilespace } from '../../../services/filespace';
import { RecycleBinIcon, WarningIcon } from '../Icons';
import { Domain, Filespace, VerificationCode, } from 'fs-api-client';
import { errorHandler } from '../../../services/errorHandler';
import { isIEorEdge, elementHasClass, isIE } from '../../../utils/utilFunctions';
import FlowManager from '../FlowManager';
import { FilespaceAuth } from 'fs-api-client';
import { createDefaultApi } from 'src/webportal/utils/createApi';
import { authenticationService } from 'src/webportal/services/authentication';
import VerificationCodeComponent from '../../authentication/VerificationCodeComponent';
interface DeleteFileSystemModalProperties {
    domain: Domain;
    filespace: Filespace;
    onFilespaceDeleted: () => void;
    onFilespaceDelete: () => void;
}

interface DeleteFileSystemModalState {
    userFilespaceName: string;
    waitingVerificationCode: boolean;
    invalidVerificationCode: boolean;
    fileSpacesMatch: boolean;
    userEmail: string;
    sendAgainState: SendAgainState;
    confirmButtonEnabled: boolean;
    deletionForbiddenError: string | null;
}

enum SendAgainState {
    SendAgainReady = 'Send again', EmailSent = 'Email sent successfully'
}

const filespacesForDeletion: string[] = [];

export class DeleteFilespaceModal extends React.Component<DeleteFileSystemModalProperties, DeleteFileSystemModalState> {
    clearCode: () => void;
    private verificationCode: string;
    private flowManager: FlowManager;
    private mutationObserver: MutationObserver | null = null;
    private sendAgainTimeOutId: any;
    constructor (props: DeleteFileSystemModalProperties) {
        super(props);
        this.deleteFileSystem = this.deleteFileSystem.bind(this);
        this.handleUserInputChanged = this.handleUserInputChanged.bind(this);
        this.canContinue = this.canContinue.bind(this);
        this.requestEmailVerificationCode = this.requestEmailVerificationCode.bind(this);
        this.resetModalState = this.resetModalState.bind(this);

        this.onSendEmailClicked = this.onSendEmailClicked.bind(this);
        this.renderEmailSendAgain = this.renderEmailSendAgain.bind(this);
        this.renderEmailSentStatus = this.renderEmailSentStatus.bind(this);
        this.onFilespaceDeleted = this.onFilespaceDeleted.bind(this);

        this.flowManager = new FlowManager(this.canContinue, this.deleteButtonPress);
        this.flowManager.registerListeners();

        this.state = {
            userFilespaceName: '',
            fileSpacesMatch: false,
            waitingVerificationCode: false,
            invalidVerificationCode: false,
            userEmail: '',
            sendAgainState: SendAgainState.SendAgainReady,
            confirmButtonEnabled: true,
            deletionForbiddenError: null
        };
    }

    render() {
        const continueBtnText = this.state.waitingVerificationCode ? 'Confirm' : 'Delete';
        const cancelDeletionBtn = <button type="button" className="link btn-short" data-dismiss="modal">Cancel</button>;
        const deleteBtn = this.state.deletionForbiddenError ? <div className="error">{this.state.deletionForbiddenError}</div> : 
                                <button disabled={!this.canContinue()} type="button" className={'btn btn-short' + (!this.state.confirmButtonEnabled ? ' loading' : '')} id="delete" onClick={() => this.deleteFileSystem()}>{continueBtnText}</button>;
        return (
            <div data-backdrop="static" className="modal fade" id="deleteModal" tabIndex={-1} role="dialog" aria-labelledby="deleteModal" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <RecycleBinIcon className="svg__modal orange" width="33px" height="42px" />
                            <h5 className="modal-title">
                                Delete {this.props.filespace.name}.{this.props.domain.name} filespace
                            </h5>
                            {!this.state.waitingVerificationCode && (<p>
                                Type the name of the filespace and press 'Delete' to continue or press 'Cancel' to
                                cancel the operation.
                            </p>)}
                            {this.state.waitingVerificationCode && (<p>
                                The verification code was sent to <strong className="nowrap"> {this.state.userEmail}</strong>. Type the verification code and press 'Confirm' to continue or press 'Cancel' to
                                cancel the operation.
                            </p>)}
                            <p className="alert alert-danger">
                                <WarningIcon width="24px" height="22px" />
                                <span>Please note that <strong>this action is irreversible</strong>, and all data stored in this filespace will be lost!</span>
                            </p>
                            <button id="deleteFileSystemModalCloseButton" type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">
                                    <CircledCrossIcon width="20px" height="20px" />
                                </span>
                            </button>
                        </div>
                        {!this.state.waitingVerificationCode && (<div className="modal-body">
                            <div className="float-label-control nolabel large row" >
                                <input data-autocomplete="off" type="text" className="form-control col-6 right-field" name="filespace" id="file-system-name" value={this.state.userFilespaceName} onChange={this.handleUserInputChanged} />
                                <input data-autocomplete="off" disabled={true} type="text" className="form-control col-6" value={'.' + this.props.domain.name} name="domain" id="domain" />
                            </div>
                        </div>)}
                        {this.state.waitingVerificationCode && (<div className="modal-body">
                            <div className="float-label-control large">
                                <div className="form" data-autocomplete="off">
                                    <div className="float-label-control no__animation six-digits ml-0 mr-0">
                                        <VerificationCodeComponent
                                            setClearCode={(clearCode) => {this.clearCode = clearCode; }}
                                            onCodeEntered={(code: number[]) =>
                                            this.verificationCode = code.toString().split(',').join('')}
                                        />
                                    </div>
                                </div>
                                <label>Verification code</label>
                                <div className="row abs">
                                    {this.state.invalidVerificationCode && <p className="left red col minitext flex4">Invalid or expired verification code provided.</p>}
                                    <p className="right col minitext"> {this.state.sendAgainState === SendAgainState.SendAgainReady ? this.renderEmailSendAgain() : this.renderEmailSentStatus()} </p>
                                </div>
                            </div>
                        </div>
                        )}

                        <div className="modal-footer">
                            {deleteBtn}
                            {cancelDeletionBtn}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        this.flowManager.registerListeners();
        this.registerModalObserver();
    }

    protected registerModalObserver() {
        const targetNode = document.getElementById('deleteModal');
        const config = { attributes: true };
        const onModalShow = this.onModalShow.bind(this);
        const onModalHide = this.onModalHide.bind(this);

        const callback = function(mutationsList: any, observer: any) {
            for (let mutation of mutationsList) {
                if (mutation.type !== 'attributes' || mutation.attributeName !== 'class' || mutation.target !== targetNode) {
                    continue;
                }
                if (elementHasClass(mutation.target, 'show')) {
                    onModalShow();
                } else {
                    onModalHide();
                }
            }
        };
        this.mutationObserver = new MutationObserver(callback);
        this.mutationObserver.observe(targetNode as any, config);
    }

    protected onModalShow() {
        this.resetModalState();
    }

    protected onModalHide() {
        this.resetModalState();
    }

    componentWillUnmount() {
        if (this.sendAgainTimeOutId) {
           clearTimeout(this.sendAgainTimeOutId);
        }
        this.flowManager.unregisterListeners();
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
        }
    }

    private canContinue(): boolean {
        return this.state.fileSpacesMatch && this.state.confirmButtonEnabled;
    }

    private renderEmailSendAgain(): JSX.Element {
        return (
            <a tabIndex={-1} href="javascript: void(0);" onClick={this.onSendEmailClicked}>{this.state.sendAgainState}</a>
        );

    }

    private renderEmailSentStatus(): JSX.Element {
        return (
            <span className="green">
                <CircledFilledCheckIcon className="checkmark" width="18px" height="18px"/>
                {this.state.sendAgainState}
            </span>
        );
    }

    private handleUserInputChanged(e: any): void {
        const trimmedValue = e.target.value.trim();
        this.setState({
            userFilespaceName: trimmedValue,
            fileSpacesMatch: trimmedValue === this.props.filespace.name
        });
    }
    private deleteButtonPress(): void {
        var pressEnterDelete = document.getElementById('delete');
        if (pressEnterDelete) {
            pressEnterDelete.click();
        }
    }

    private deleteFileSystem(): void {
        this.setState({deletionForbiddenError: null});
        if (!this.state.fileSpacesMatch) {
            return;
        }
        if (filespacesForDeletion.includes(this.props.filespace.id!) && !this.state.waitingVerificationCode) {
            this.setState({waitingVerificationCode: true});
            return;
        }
        this.setState({confirmButtonEnabled: false});
        let code: VerificationCode | undefined = undefined;
        if (this.verificationCode) {
            code = { verificationType: VerificationCode.VerificationTypeEnum.Email, code: this.verificationCode };
        }
        deleteFilespace(this.props.filespace.id!, code)
            .then(this.onFilespaceDeleted)
            .then(() => {
                this.setState({confirmButtonEnabled: true});
                this.verificationCode = '';
            })
            .catch((error) => {
                this.handleFsDeleteError(error);
            });
    }

    private handleFsDeleteError(error: any) {
        if (isIE()) {
            this.handleIEFsDeleteError(error);
            return;
        }

        this.verificationCode = '';
        if (this.isEmailVerificationRequired(error) && !this.state.waitingVerificationCode) {
            this.requestEmailVerificationCode();
            return;
        } else if (error.body.status === 401) {
            this.setState({invalidVerificationCode: true});
        } else {
            errorHandler(error);
        }
        if (error.body.status === 403) {
            this.setState({deletionForbiddenError: error.body.message});
        }
        this.setState({confirmButtonEnabled: true});
    }

    private handleIEFsDeleteError(error: any) {
        // Because of bug in one of our dependencies
        // when we receive http 401 response, the library
        // does not parse the error properly and we have no access
        // to the error code or any other information.
        const is401Error = error.body === undefined;
        if (is401Error) {
            if (!filespacesForDeletion.includes(this.props.filespace.id!)) {
                this.requestEmailVerificationCode();
                filespacesForDeletion.push(this.props.filespace.id!);
                return;
            } else {
                this.setState({invalidVerificationCode: true});
            }
        } else {
            errorHandler(error);
        }
        this.setState({confirmButtonEnabled: true});
    }
    private async requestEmailVerificationCode() {
        let currentUserEmail = '';
        try {
            const currentUserEmailPromise = authenticationService.getCurrentUserEmail();
            const api = await createDefaultApi();
            await api.sendFilespaceVerificationCode({
                verificationType: FilespaceAuth.VerificationTypeEnum.Email,
                id: this.props.filespace.id!,
                operationType: FilespaceAuth.OperationTypeEnum.Delete
            });
            currentUserEmail = await currentUserEmailPromise;
            filespacesForDeletion.push(this.props.filespace.id!);
        } catch (error) {
            console.error(error.message);
        }
        this.setState({userEmail: currentUserEmail, invalidVerificationCode: false, waitingVerificationCode: true, confirmButtonEnabled: true});
    }

    private onFilespaceDeleted() {
        let deleteFileSystemModalCloseButton = document.getElementById('deleteFileSystemModalCloseButton');
        if (deleteFileSystemModalCloseButton) {
            deleteFileSystemModalCloseButton.click();
        }
        if (isIEorEdge()) {
            // We call it manually on edge or IE, because of a bug in one
            // of the dependencies of the libraries that we use
            setTimeout((() => {
                this.props.onFilespaceDeleted();
            }).bind(this),
                       1000);
        } else {
            this.props.onFilespaceDeleted();
        }
    }

    private resetModalState() {
        this.setState({
            userFilespaceName: '',
            fileSpacesMatch: false,
            waitingVerificationCode: false,
            invalidVerificationCode: false,
            deletionForbiddenError: null
        });
    }

    private isEmailVerificationRequired(error: any) {
        return error && error.body && error.body.status === 401 &&
               error.body.authorizationType === 'emailVerificationCode';
    }

    private async onSendEmailClicked() {
        if (this.state.sendAgainState !== SendAgainState.SendAgainReady) {
            return;
        }
        try {
            await this.requestEmailVerificationCode();
            this.clearCode();
            this.setState({sendAgainState: SendAgainState.EmailSent});
            this.sendAgainTimeOutId = setTimeout(() => {
                this.sendAgainTimeOutId = undefined;
                this.setState({sendAgainState: SendAgainState.SendAgainReady});
            },                                   5000);
        } catch (e) {
                console.error(e.message);

        }
    }
}


// WEBPACK FOOTER //
// ./src/webportal/components/common/modals/DeleteFilespaceModal.tsx